export function CalendarWithTextIcon({
  size = 16,
  fill = "#fff",
  stroke = '#000',
  text = 'M+1',
  ...params
}) {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...params}>
      <rect x="10" y="20" width="80" height="70" rx="10" ry="10" fill={fill} stroke={stroke} stroke-width="5" />
      <line x1="10" y1="35" x2="90" y2="35" stroke={stroke} stroke-width="5" />
      <rect x="25" y="5" width="10" height="20" rx="2" fill={stroke} />
      <rect x="65" y="5" width="10" height="20" rx="2" fill={stroke} />
      <text x="50" y="70" font-size="28" text-anchor="middle" fill={stroke} font-family="sans-serif">{text}</text>
    </svg>
  )
}
